import { createGlobalStyle } from 'antd-style';

const TypographyGlobalStyles = createGlobalStyle({
  a: {
    textDecoration: 'none',

    '&, .ant-typography &': {
      '&, &:link, &:visited': {
        color: 'inherit',
      },
      '&:hover': {
        color: 'inherit',
        textDecoration: 'none',
      },
    },
  },
  '.Clickable': {
    cursor: 'pointer',

    '&.disabled': {
      cursor: 'not-allowed',
    },
  },
});

export default TypographyGlobalStyles;
